import React from "react";
import { Row, Col } from "antd";
import styles from "./styles/DetailSection.scss";

import IndexSection from "./IndexSection";

function DetailSection({ adDetails, category, adId, hrPageName, insertAfterSectionName, extraContent }: any) {
  const renderDynamicSections = (adDetails: any) => {
    if (!adDetails) {
      return null;
    }

    return adDetails.map((groupData: any, index: any) => (
      <React.Fragment key={`${index}-wrap`}>
        <section
          key={groupData.name}
          id={groupData.name}
          className={styles.detailSection}
        >
          <IndexSection
            sectionName={groupData.name}
            type={groupData.type}
            data={groupData.data}
            category={category}
            adId={adId}
            hrPageName={hrPageName}
          />
        </section>
        {extraContent && insertAfterSectionName && groupData.name === insertAfterSectionName && extraContent}
      </React.Fragment>
    ));
  };

  return (
    <Row>
      <Col xs={24} sm={24} md={24}>
        {renderDynamicSections(adDetails)}
      </Col>
    </Row>
  );
}


DetailSection.defaultProps = {
  adDetails: {}
};


export default DetailSection


// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageWeb/DetailSection.tsx